export default {
  baseUrl: '/api',
}
